export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7372.4e65fea4.jpg";